import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import AirplayIcon from "@material-ui/icons/Airplay";
import AndroidIcon from "@material-ui/icons/Android";
import CloseIcon from "@material-ui/icons/Close";
import CreateIcon from "@material-ui/icons/Create";
import ErrorIcon from "@material-ui/icons/Error";
import GetAppIcon from "@material-ui/icons/GetApp";
import HelpIcon from "@material-ui/icons/HelpOutline";
import InfoIcon from "@material-ui/icons/Info";
import LaunchIcon from "@material-ui/icons/Launch";
import VisitorsIcon from "@material-ui/icons/Visibility";
import Icon from "@mdi/react";
import { colord } from "colord";
import React, { useState } from "react";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { defaultColor } from "../../constants/DefaultColor";
import { languages } from "../../constants/languages";
import { downloadTournamentPoster } from "../../util/tournamentPosterDownload";
// import WebIcon from "@material-ui/icons/WebAsset";
// import SmartphoneIcon from "@material-ui/icons/Smartphone";
import { FormHelperText } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import {
  mdiAccountPlus,
  mdiApple,
  mdiCalendarRange,
  mdiFormatListNumbered,
  mdiImageAlbum,
  mdiQrcode,
  mdiTrophy,
  mdiTshirtCrew,
  mdiWhistle,
} from "@mdi/js";
import { Link } from "react-router-dom";
import AdminLoginLink from "./AdminLoginLink";
import LivePage from "./LivePage";

const styles = {
  textField: { marginBottom: 15 },
  paper: { marginBottom: 1 },
};

const LiveLinkSettings = (props) => {
  const [downloadingPoster, setDownloadingPoster] = useState(false);
  const [posterErrorOpen, setPosterErrorOpen] = useState(false);
  const posterTipBackground = colord(
    props.tournament.color || defaultColor,
  )
    .alpha(0.15)
    .toRgbString();

  const handleClosePosterError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setPosterErrorOpen(false);
  };

  const handleDownloadPoster = async () => {
    setDownloadingPoster(true);
    try {
      await downloadTournamentPoster(
        props.tournament,
        props.daysByKey || {},
        props.sportParks || [],
      );
    } catch (err) {
      console.error("Tournament poster download error:", err);
      setPosterErrorOpen(true);
    } finally {
      setDownloadingPoster(false);
    }
  };

  const pages = [
    {
      title: languages.livePages.tournament,
      name: "showTournamentInfo",
      image: (
        <Icon
          path={mdiTrophy}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px 0px" }}
        />
      ),
      checked:
        props.tournament.showTournamentInfo === undefined ||
        props.tournament.showTournamentInfo
          ? true
          : false,
      button: (
        <Button
          onClick={props.handleToTournamentInfo}
          size="small"
          variant="outlined"
          style={{
            padding: 5,
            marginRight: "auto",
            marginLeft: "auto",
            width: "calc(100% - 20px)",
            marginBottom: 10,
            display: "flex",
          }}
        >
          <CreateIcon style={{ height: 16, width: 16, marginRight: 5 }} />
          {languages.tournament.editPage}
        </Button>
      ),
    },
    {
      title: props.tournament.individualPlayers
        ? languages.livePages.myTeam2
        : languages.livePages.myTeam,
      name: "showTeamPage",
      image: (
        <Icon
          path={mdiTshirtCrew}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px" }}
        />
      ),
      checked:
        props.tournament.showTeamPage === undefined ||
        props.tournament.showTeamPage
          ? true
          : false,
    },
    {
      title: languages.livePages.positions,
      name: "showStandings",
      image: (
        <Icon
          path={mdiFormatListNumbered}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px" }}
        />
      ),
      checked:
        props.tournament.showStandings === undefined ||
        props.tournament.showStandings
          ? true
          : false,
    },
    {
      title: languages.livePages.schedule,
      name: "showSchedule",
      image: (
        <Icon
          path={mdiCalendarRange}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px" }}
        />
      ),
      checked:
        props.tournament.showSchedule === undefined ||
        props.tournament.showSchedule
          ? true
          : false,
    },
    {
      title: props.tournament.useJudges
        ? languages.referees.judges
        : languages.schedule.referees,
      name: "showRefereeSchedule",
      image: (
        <Icon
          path={mdiWhistle}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px" }}
        />
      ),
      checked: props.tournament.showRefereeSchedule || false,
    },
    {
      title: languages.livePages.signup,
      name: "showSignupPage",
      image: (
        <Icon
          path={mdiAccountPlus}
          color="rgba(0, 0, 0, 0.04)"
          style={{ width: "100%", padding: "25px 50px 0px" }}
        />
      ),
      checked: props.tournament.showSignupPage || false,
      button: (
        <Button
          onClick={props.handleToSignup}
          size="small"
          variant="outlined"
          style={{
            padding: 5,
            marginRight: "auto",
            marginLeft: "auto",
            width: "calc(100% - 20px)",
            marginBottom: 10,
            display: "flex",
          }}
        >
          <CreateIcon style={{ height: 16, width: 16, marginRight: 5 }} />
          {languages.tournament.editPage}
        </Button>
      ),
    },
  ];

  return (
    <div style={{ width: "100%", paddingTop: 30, paddingBottom: 50 }}>
      <div style={{ width: 650, maxWidth: "97%", margin: "auto" }}>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <Paper style={{ padding: 20, height: "100%" }}>
              <Typography
                variant="h6"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                {/* <WebIcon style={{ marginRight: 5 }} /> */}
                {languages.tournament.website}
                <Chip
                  size="small"
                  label={
                    props.tournament.liveLink
                      ? languages.present.active
                      : languages.present.inactive
                  }
                  style={
                    props.tournament.liveLink
                      ? {
                          marginLeft: 10,
                          backgroundColor: "#9CE2B6",
                          color: "#126E35",
                        }
                      : {
                          marginLeft: 10,
                          backgroundColor: "#FCBABA",
                          color: "#8E2928",
                        }
                  }
                />
                <IconButton
                  size="small"
                  disabled={!props.tournament.liveLink}
                  aria-label="Open"
                  style={{ marginLeft: "auto" }}
                  target="_blank"
                  href={
                    "https://" +
                    (props.tournament.isPSD || props.tournament.crqpsd
                      ? "tournify.prosoccerdata.com/"
                      : "tournifyapp.com/live/") +
                    props.tournament.liveLink
                  }
                >
                  <LaunchIcon />
                </IconButton>
              </Typography>
              <Typography variant="caption">
                {languages.tournament.publicLinkDescription}
              </Typography>
              {!props.tournament.liveLink ? (
                <div style={{ marginTop: 10 }}>
                  <Button
                    variant="outlined"
                    onClick={props.toggleLiveLinkDialog}
                    size="small"
                  >
                    {languages.tournament.makeLiveLink}
                  </Button>
                </div>
              ) : (
                <>
                  <TextField
                    onClick={props.toggleLiveLinkDialog}
                    value={
                      props.tournament.liveLink
                        ? (props.tournament.isPSD || props.tournament.crqpsd
                            ? "tournify.prosoccerdata.com/"
                            : "tournifyapp.com/live/") +
                          props.tournament.liveLink
                        : ""
                    }
                    style={{ marginBottom: 15, marginTop: 15 }}
                    fullWidth
                    label={languages.tournament.publicLink}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment
                          position="start"
                          style={{ marginRight: 0, whiteSpace: "nowrap" }}
                        >
                          <AirplayIcon
                            style={{ color: "gray", marginRight: 10 }}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <br />
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <Typography variant="caption">
                      <VisitorsIcon
                        style={{
                          height: 20,
                          width: 20,
                          marginRight: 5,
                          verticalAlign: "top",
                          paddingBottom: 1,
                          color: "grey",
                        }}
                      />
                      {(props.numVisits !== null ? props.numVisits : "") +
                        " " +
                        languages.tournament.numVisits}{" "}
                      {/* <Tooltip title={languages.tournament.numVisitsText}>
                          <HelpIcon style={{ height: 15, width: 15 }} />
                        </Tooltip> */}
                    </Typography>
                    <Typography
                      variant="caption"
                      style={{ display: "flex", marginLeft: "auto" }}
                      onClick={props.toggleQRCodeDialog}
                    >
                      <Icon
                        path={mdiQrcode}
                        size={0.8}
                        color={"rgba(0, 0, 0, 0.54)"}
                      />
                      <span
                        style={{
                          paddingLeft: 5,
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {" " + languages.tournament.qrCode}
                      </span>
                    </Typography>
                  </div>
                </>
              )}
            </Paper>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Paper style={{ padding: 20, height: "100%" }}>
              <Typography
                variant="h6"
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: 10,
                }}
              >
                {/* <SmartphoneIcon style={{ marginRight: 5 }} /> */}
                {languages.tournament.app}
                <Chip
                  size="small"
                  label={
                    props.tournament.ia
                      ? languages.present.active
                      : languages.present.inactive
                  }
                  style={
                    props.tournament.ia
                      ? {
                          marginLeft: 10,
                          backgroundColor: "#9CE2B6",
                          color: "#126E35",
                        }
                      : {
                          marginLeft: 10,
                          backgroundColor: "#FCBABA",
                          color: "#8E2928",
                        }
                  }
                />
                {/* <Chip
                  size="small"
                  variant="outlined"
                  label={languages.present.new}
                  style={{
                    marginLeft: 10,
                  }}
                /> */}
                <IconButton
                  size="small"
                  aria-label="Open"
                  style={{ marginLeft: "auto" }}
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.tournifyapp"
                >
                  <AndroidIcon />
                </IconButton>
                <IconButton
                  size="small"
                  aria-label="Open"
                  target="_blank"
                  href="https://apps.apple.com/nl/app/tournify/id1504284547"
                >
                  <Icon
                    path={mdiApple}
                    size={1}
                    color={"rgba(0, 0, 0, 0.54)"}
                  />
                </IconButton>
              </Typography>
              <Typography variant="caption">
                {languages.tournament.appDescription}
              </Typography>
              <FormGroup style={{ marginTop: 5, marginBottom: 5 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={props.tournament.ia ? true : false}
                      onChange={
                        props.tournament.ia
                          ? props.removeFromApp
                          : props.allowedToAddToApp
                          ? props.toggleInAppDialog
                          : props.toggleUpgradeDialog
                      }
                      color="primary"
                      name="ShowInApp"
                    />
                  }
                  label={languages.present.showInApp}
                />
              </FormGroup>
              <div>
                <Button
                  variant="outlined"
                  onClick={props.toggleNotificationsDialog}
                  size="small"
                  disabled={!props.tournament.ia}
                >
                  {languages.present.setNotifications}
                </Button>
              </div>
              {props.tournament.ia && (
                <div style={{ display: "flex", marginTop: 10 }}>
                  <Typography variant="caption">
                    <VisitorsIcon
                      style={{
                        height: 20,
                        width: 20,
                        marginRight: 5,
                        verticalAlign: "top",
                        paddingBottom: 1,
                        color: "grey",
                      }}
                    />
                    {(props.numVisitsApp !== null ? props.numVisitsApp : "") +
                      " " +
                      languages.tournament.numUsers}{" "}
                  </Typography>
                </div>
              )}
            </Paper>
          </Grid>
        </Grid>
        {(props.tournament.name || "").trim() && (
          <Typography
            component="div"
            variant="body2"
            style={{
              background: posterTipBackground,
              padding: 10,
              borderRadius: 5,
              marginBottom: 20,
              marginTop: 20,
              display: "flex",
              alignItems: "center",
            }}
          >
            <Icon
              path={mdiImageAlbum}
              size={0.75}
              color="rgba(0, 0, 0, 1)"
              style={{ flexShrink: 0, marginRight: 8 }}
            />
            <span style={{ flex: 1 }}>
              {languages.tournament.tournamentPosterDescription}
            </span>
            <Button
              variant="outlined"
              size="small"
              onClick={handleDownloadPoster}
              disabled={downloadingPoster}
              startIcon={
                downloadingPoster ? (
                  <CircularProgress size={16} />
                ) : (
                  <GetAppIcon />
                )
              }
              style={{ marginLeft: 12, flexShrink: 0 }}
            >
              {languages.tournament.downloadPoster}
            </Button>
          </Typography>
        )}
        <br />
        <Typography variant="h6">{languages.tournament.pagesOnLive}</Typography>
        <Typography variant="caption">
          {languages.tournament.pagesOnLiveText}
        </Typography>
        <Grid container spacing={2} style={{ marginTop: 10 }}>
          {pages.map((page) => {
            return (
              <Grid key={page.name} item xs={6} sm={6} md={4} lg={4}>
                <LivePage
                  pageTitle={page.title}
                  pageId={page.name}
                  image={page.image}
                  checked={page.checked}
                  handleShowPageCheck={props.handleShowPageCheck}
                  button={page.button}
                  buttonDescription={page.buttonDescription}
                />
              </Grid>
            );
          })}
        </Grid>
        <Typography variant="h6" style={{ marginTop: 25, marginBottom: 10 }}>
          {languages.tournament.generalSettingsLive}
        </Typography>
        <div style={styles.paper}>
          {(props.tournament.showTeamPage === undefined ||
            props.tournament.showTeamPage) &&
            props.tournament.online && (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.tournament.requireCheckIn === true}
                      onChange={props.handleRequireCheckInChange}
                      color="primary"
                      name="requireCheckIn"
                    />
                  }
                  label={
                    <div>
                      {languages.formatString(
                        languages.tournament.requireCheckIn,
                        props.tournament.individualPlayers
                          ? languages.teams.players
                          : languages.tournament.teams
                      ) + " "}
                      <Tooltip title={languages.tournament.requireCheckInText}>
                        <HelpIcon
                          style={{
                            height: 15,
                            width: 15,
                            position: "relative",
                            top: 2,
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                />
                {props.tournament.requireCheckIn === true && (
                  <div>
                    <div>
                      <FormHelperText>
                        <Link to="/account">
                          {languages.general.timezone +
                            ": " +
                            (props.tournament.timezone || "Europe/Amsterdam")}
                        </Link>
                        .
                      </FormHelperText>
                    </div>
                    <div style={{ display: "flex" }}>
                      <TextField
                        style={{ marginRight: 10 }}
                        fullWidth
                        margin="dense"
                        label={languages.tournament.checkInStartTime}
                        name="checkInStart"
                        type="time"
                        onClick={props.toggleCheckInDialog}
                        // onChange={props.handleCheckInTimeChange}
                        value={props.tournament.checkInStart || ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 60, // 1 min
                        }}
                      />
                      <TextField
                        fullWidth
                        margin="dense"
                        label={languages.tournament.checkInEndTime}
                        name="checkInEnd"
                        type="time"
                        onClick={props.toggleCheckInDialog}
                        // onChange={props.handleCheckInTimeChange}
                        value={props.tournament.checkInEnd || ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{
                          step: 60, // 1 min
                        }}
                      />
                    </div>
                  </div>
                )}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={props.tournament.requireEvidence === true}
                      onChange={props.handleRequireEvidenceChange}
                      color="primary"
                      name="requireEvidence"
                    />
                  }
                  label={
                    <div>
                      {languages.formatString(
                        languages.tournament.requireEvidence,
                        props.tournament.individualPlayers
                          ? languages.teams.players
                          : languages.tournament.teams
                      ) + " "}
                      {/* <Tooltip
                          title={languages.tournament.requireEvidenceText}
                        >
                          <HelpIcon
                            style={{
                              height: 15,
                              width: 15,
                              position: "relative",
                              top: 2,
                            }}
                          />
                        </Tooltip> */}
                    </div>
                  }
                />
              </div>
            )}

          {(props.tournament.showTeamPage === undefined ||
            props.tournament.showTeamPage) &&
            props.tournament.online && (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      props.tournament.submitPreviousBeforeSubmit !== false
                    }
                    onChange={props.handleSubmitPreviousChange}
                    color="primary"
                    name="submitPreviousBeforeSubmit"
                  />
                }
                label={languages.formatString(
                  languages.tournament.submitPreviousBeforeSubmit,
                  props.tournament.individualPlayers
                    ? languages.teams.players
                    : languages.tournament.teams
                )}
              />
            )}

          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    props.tournament.allowSubmitAllPhases === undefined
                      ? true
                      : !props.tournament.allowSubmitAllPhases
                  }
                  onChange={props.handleShowPageChange}
                  color="primary"
                  name="allowSubmitAllPhases"
                />
              }
              label={
                <div>
                  {languages.formatString(
                    languages.tournament.onlyAllowSubmitCurrentPhase,
                    props.tournament.individualPlayers
                      ? languages.teams.players
                      : languages.tournament.teams,
                    props.tournament.useJudges
                      ? languages.referees.judgesLow
                      : languages.schedule.refereesLow
                  ) + " "}
                  <Tooltip
                    title={languages.formatString(
                      languages.tournament.onlyAllowSubmitCurrentPhase2,
                      props.tournament.individualPlayers
                        ? languages.teams.playersLow
                        : languages.tournament.teamsLow,
                      props.tournament.useJudges
                        ? languages.referees.judgesLow
                        : languages.schedule.refereesLow
                    )}
                  >
                    <HelpIcon
                      style={{
                        height: 15,
                        width: 15,
                        position: "relative",
                        top: 2,
                      }}
                    />
                  </Tooltip>
                </div>
              }
            />
          </div>

          {props.tournamentHasPlayers && (
              <div>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        props.tournament.playersHidden === undefined
                          ? true
                          : !props.tournament.playersHidden
                      }
                      onChange={props.handleShowPageChange}
                      color="primary"
                      name="playersHidden"
                    />
                  }
                  label={
                    <div>
                      {languages.tournament.showPlayersOnLive + " "}
                      <Tooltip
                        title={languages.tournament.showPlayersOnLiveText}
                      >
                        <HelpIcon
                          style={{
                            height: 15,
                            width: 15,
                            position: "relative",
                            top: 2,
                          }}
                        />
                      </Tooltip>
                    </div>
                  }
                />
              </div>
            )}
        </div>
        <div style={styles.paper}>
          {(props.tournament.showStandings === undefined ||
            props.tournament.showStandings ||
            props.tournament.showTeamPage === undefined ||
            props.tournament.showTeamPage) && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      props.tournament.showScheduleStandings === undefined ||
                      props.tournament.showScheduleStandings === true
                        ? true
                        : false
                    }
                    onChange={props.handleShowPageChange}
                    color="primary"
                    name="showScheduleStandings"
                  />
                }
                label={<div>{languages.tournament.showScheduleStandings}</div>}
              />
            </div>
          )}
          {(props.tournament.showStandings === undefined ||
            props.tournament.showStandings) && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={
                      props.tournament.showRankingInStandings === true
                        ? true
                        : false
                    }
                    onChange={props.handleShowPageChange}
                    color="primary"
                    name="showRankingInStandings"
                  />
                }
                label={
                  <div>
                    {languages.tournament.showRankingInStandings + " "}
                    <Tooltip
                      title={languages.formatString(
                        languages.results.rankingDescription,
                        props.tournament.individualPlayers
                          ? languages.teams.playersLow
                          : languages.tournament.teamsLow
                      )}
                    >
                      <HelpIcon
                        style={{
                          height: 15,
                          width: 15,
                          position: "relative",
                          top: 2,
                        }}
                      />
                    </Tooltip>
                  </div>
                }
              />
            </div>
          )}
          {(props.tournament.showStandings === undefined ||
            props.tournament.showStandings ||
            props.tournament.showTeamPage === undefined ||
            props.tournament.showTeamPage) && (
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.tournament.showCriteria || false}
                    onChange={props.handleShowPageChange}
                    color="primary"
                    name="showCriteria"
                  />
                }
                label={<div>{languages.tiebreakers.showCriteria}</div>}
              />
            </div>
          )}
          <div>
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.tournament.use12HTime === true ? true : false}
                  onChange={props.handleShowPageChange}
                  color="primary"
                  name="use12HTime"
                />
              }
              label={<div>{languages.tournament.use12HTime}</div>}
            />
          </div>
          {(props.tournament.showStandings === undefined ||
          props.tournament.showStandings ||
          props.tournament.showTeamPage === undefined ||
          props.tournament.showTeamPage
            ? true
            : false) && (
            <div style={{ marginTop: 30 }}>
              <Typography variant="h6">
                {languages.tournament.standingsTable}
              </Typography>
              <div style={{ overflow: "auto" }}>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <th
                        colSpan={props.showSetColumns ? 9 : 6}
                        scope="col"
                      ></th>
                      <th
                        colSpan={3}
                        scope="col"
                        style={{
                          backgroundColor: "rgb(233, 233, 233)",
                          borderTopLeftRadius: 10,
                          borderTopRightRadius: 10,
                        }}
                      >
                        <FormControlLabel
                          control={
                            <Switch
                              size="small"
                              name="standingsTableWithPoints"
                              onChange={props.handleSwitch}
                              color="primary"
                              checked={
                                props.tournament.standingsTableWithPoints ||
                                false
                              }
                            />
                          }
                          label={languages.results.pouleResults.pointsLong}
                        />
                      </th>
                    </tr>
                    <tr>
                      <th
                        scope="col"
                        style={{ textAlign: "start", fontWeight: "bold" }}
                      >
                        {languages.tournament.screen}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {languages.results.pouleResults.played}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {languages.results.pouleResults.won}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {languages.results.pouleResults.tie}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {languages.results.pouleResults.loss}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {languages.results.pouleResults.points}
                      </th>
                      {props.showSetColumns && (
                        <>
                          <th scope="col" style={{ fontWeight: "normal" }}>
                            {languages.results.pouleResults.setsFor}
                          </th>
                          <th scope="col" style={{ fontWeight: "normal" }}>
                            {languages.results.pouleResults.setsAgainst}
                          </th>
                          <th scope="col" style={{ fontWeight: "normal" }}>
                            {languages.results.pouleResults.setsDifference}
                          </th>
                        </>
                      )}
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {props.tournament.standingsTableWithPoints
                          ? languages.results.pouleResults.pointsFor
                          : languages.results.pouleResults.goalsFor}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {props.tournament.standingsTableWithPoints
                          ? languages.results.pouleResults.pointsAgainst
                          : languages.results.pouleResults.goalsAgainst}
                      </th>
                      <th scope="col" style={{ fontWeight: "normal" }}>
                        {props.tournament.standingsTableWithPoints
                          ? languages.results.pouleResults.pointsDifference
                          : languages.results.pouleResults.goals}
                      </th>
                      {Object.keys(props.tournament.customPoints || {}).map(
                        (key, i) => {
                          let customPoints = props.tournament.customPoints[key];

                          return (
                            <th
                              key={i}
                              scope="col"
                              style={{ fontWeight: "normal" }}
                            >
                              {customPoints["abbr"] || ""}
                            </th>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td>{languages.tournament.normal}</td>
                      {props.standingColumns.map((f) => {
                        let pouleStandings =
                          ((props.tournament.pouleStandings || {}).normal || {})
                            .default || {};

                        let defaultChecked = [
                          "G",
                          "W",
                          "GL",
                          "V",
                          "P",
                          "DPV",
                          "DPT",
                          "+/-",
                        ];
                        let checked = pouleStandings[f] || false;
                        if (
                          checked === false &&
                          defaultChecked.indexOf(f) !== -1 &&
                          pouleStandings[f] === undefined
                        ) {
                          checked = true;
                        }

                        return (
                          <td key={f} style={{ textAlign: "center" }}>
                            <Checkbox
                              style={{ padding: 3 }}
                              color="primary"
                              name={f}
                              checked={checked}
                              onChange={(e) => {
                                props.handleCheck(e, "normal", "default");
                              }}
                            />
                          </td>
                        );
                      })}
                      {Object.keys(props.tournament.customPoints || {}).map(
                        (key, i) => {
                          let pouleStandings =
                            (
                              (props.tournament.pouleStandings || {}).normal ||
                              {}
                            ).custom || {};
                          return (
                            <td key={i} style={{ textAlign: "center" }}>
                              <Checkbox
                                style={{ padding: 3 }}
                                color="primary"
                                name={key}
                                checked={pouleStandings[key] || false}
                                onChange={(e) => {
                                  props.handleCheck(e, "normal", "custom");
                                }}
                              />
                            </td>
                          );
                        }
                      )}
                    </tr>
                    <tr>
                      <td>{languages.tournament.mobile}</td>
                      {props.standingColumns.map((f) => {
                        let pouleStandings =
                          ((props.tournament.pouleStandings || {}).mobile || {})
                            .default || {};
                        let defaultChecked = ["G", "P", "+/-"];
                        let checked = pouleStandings[f] || false;
                        if (
                          checked === false &&
                          defaultChecked.indexOf(f) !== -1 &&
                          pouleStandings[f] === undefined
                        ) {
                          checked = true;
                        }

                        return (
                          <td key={f} style={{ textAlign: "center" }}>
                            <Checkbox
                              style={{ padding: 3 }}
                              color="primary"
                              name={f}
                              checked={checked}
                              onChange={(e) => {
                                props.handleCheck(e, "mobile", "default");
                              }}
                            />
                          </td>
                        );
                      })}
                      {Object.keys(props.tournament.customPoints || {}).map(
                        (key, i) => {
                          let pouleStandings =
                            (
                              (props.tournament.pouleStandings || {}).mobile ||
                              {}
                            ).custom || {};
                          return (
                            <td key={i} style={{ textAlign: "center" }}>
                              <Checkbox
                                style={{ padding: 3 }}
                                color="primary"
                                name={key}
                                checked={pouleStandings[key] || false}
                                onChange={(e) => {
                                  props.handleCheck(e, "mobile", "custom");
                                }}
                              />
                            </td>
                          );
                        }
                      )}
                    </tr>
                  </tbody>
                </table>
                {props.errorMessagePouleStandings && (
                  <div>
                    <Typography style={{ color: "red", marginTop: 10 }}>
                      {props.errorMessagePouleStandings}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          )}

          <div style={{ marginTop: 30 }}>
            <Typography variant="h6">
              {languages.admins.adminLoginLink}
            </Typography>
            <Typography variant="caption">
              {languages.formatString(
                languages.admins.adminLoginLinkDescription,
                props.tournament.individualPlayers
                  ? languages.teams.playersLow
                  : languages.tournament.teamsLow,
                props.tournament.useJudges
                  ? languages.referees.judgesLow
                  : languages.schedule.refereesLow
              )}
            </Typography>
            {!props.tournament.liveLink && (
              <div style={{ marginTop: 10 }}>
                <Typography
                  variant="body2"
                  style={{
                    background: "rgb(236, 239, 241)",
                    padding: 10,
                    borderRadius: 5,
                    width: "100%",
                  }}
                >
                  <InfoIcon
                    style={{
                      height: 15,
                      width: 15,
                      marginRight: 3,
                      top: 2,
                      position: "relative",
                    }}
                  />

                  {languages.tournament.noLiveLink}
                </Typography>
              </div>
            )}
            {props.tournament.liveLink && (
              <AdminLoginLink tournament={props.tournament} />
            )}
          </div>
        </div>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={posterErrorOpen}
        autoHideDuration={6000}
        onClose={handleClosePosterError}
      >
        <SnackbarContent
          style={{ backgroundColor: "#d32f2f", color: "white" }}
          aria-describedby="poster-download-error"
          message={
            <span
              id="poster-download-error"
              style={{ display: "flex", alignItems: "center" }}
            >
              <ErrorIcon style={{ marginRight: 8 }} />
              {languages.tournament.downloadPosterError}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClosePosterError}
            >
              <CloseIcon fontSize="small" />
            </IconButton>,
          ]}
        />
      </Snackbar>
    </div>
  );
};

export default LiveLinkSettings;
